// extracted by mini-css-extract-plugin
export default {"container":"dSEAu","searchLabel":"cmWh1","query":"VREGb","filtersContainer":"btleQ","filters":"bwSbK","strikethroughText":"Sf6_f"};